import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const AppCard = ({
  app,
  compact,
  isFavourite,
  onToggleFavourite,
  onOpen,
}) => (
  <motion.article
    layout
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    whileHover={{ y: compact ? -2 : -4 }}
    className={`tool-card group relative overflow-hidden ${compact ? 'tool-card-compact' : ''}`}
    style={{
      background: 'linear-gradient(145deg,rgba(14,21,27,0.96),rgba(8,12,16,0.94))',
      border: '1px solid rgba(150,178,194,0.18)',
      backdropFilter: 'blur(12px)',
    }}
  >
    <div
      className="absolute inset-x-0 top-0 h-px opacity-0 group-hover:opacity-100 transition-opacity"
      style={{
        background: `linear-gradient(90deg,transparent,${app.iconColor},transparent)`,
      }}
    />

    <button
      type="button"
      onClick={() => onToggleFavourite(app.id)}
      className={`favourite-button ${isFavourite ? 'is-favourite' : ''}`}
      aria-label={isFavourite ? `Remove ${app.title} from favourites` : `Favourite ${app.title}`}
      title={isFavourite ? 'Remove from favourites' : 'Add to favourites'}
    >
      <SafeIcon name="Star" />
    </button>

    <a
      href={app.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => onOpen(app.id)}
      className="tool-card-link"
    >
      <div
        className="tool-icon"
        style={{
          color: app.iconColor,
          background: `${app.iconColor}16`,
          borderColor: `${app.iconColor}3f`,
        }}
      >
        <SafeIcon name={app.icon} />
      </div>

      <div className="tool-card-copy">
        <div className="tool-title-row">
          <div>
            <h2>{app.label}</h2>
            <p className="tool-product-name">{app.title} · {app.category}</p>
          </div>
          <div className="tool-statuses">
            {app.recentlyAdded && <span className="status-new">Recently added</span>}
            {app.status && <span className="status-muted">{app.status}</span>}
          </div>
        </div>

        <p className="tool-description">{app.description}</p>

        <div className="tool-card-meta">
          <div className="flex flex-wrap gap-1.5">
            {app.tags.map((tag) => (
              <span key={tag} className="tool-tag">{tag}</span>
            ))}
          </div>
          <span className="tool-domain">{app.domain}</span>
        </div>
      </div>

      <SafeIcon name="ArrowUpRight" className="tool-open-icon" />
    </a>
  </motion.article>
);

export default AppCard;